<script lang="ts">
    import { _ } from "svelte-i18n";
    import type { TitledControlManager } from "./TitledControlManager";
    import Control from "./Control.svelte";
    import CollapsibleControl from "./CollapsibleControl.svelte";

    let className: string = "";
    export { className as class };
    export let manager: TitledControlManager;
    
    const collapsedStore = manager.getCollapsedStore();
    const onToggle = () => {
        $collapsedStore = !$collapsedStore;
    };
</script>

<CollapsibleControl class={className} {manager}>
    <div slot="content" class="container rounded p-0 pb-1">
        <div
            class="primary-desat-background border-0 p-4">
            <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-0">
                    <slot name="title" />
                </h5>
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <button class="input-group-text border-0 p-0" on:click={onToggle}
                    ><i class="fe fe-x"></i></button>
            </div>
        </div>
        <slot name="content" />
    </div>
    <div slot="content-collapsed">
        <slot name="content-collapsed" />
    </div>
</CollapsibleControl>